<template>
    <div class="footer">
        <div class="footer-box">
            <div class="footer-box-logo">
                <img class="footer-logo" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/images/footer-logo.png" @click="toHome" alt="">
                <h2>博努力（北京）仿真技术有限公司</h2>
                <p><a style="color:white;" href="https://beian.miit.gov.cn"target="_blank">许可证号：京ICP备12029869号</a></p>
                <div style="display: flex;justify-content: flex-start;align-items: center;" class="footer-p">
                    <img class="footer-police" src="../assets/footer/gongan.png">
                    <p><a style="color:white;" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802034085"target="_blank">京公网安备11010802034085号</a></p>         
                </div>
                
            </div>
            <div class="footer-box-contact">
                <h1>联系我们</h1>
                <p>地址：北京市海淀区上地信息产业基地开拓路1号1层B1008</p>
                <p>邮编：100085</p>
                <p>电话：010-56293048</p>
                <p>技术支持QQ群：488718249</p>
            </div>
            <div class="footer-box-erweima">
                <h1>公司二维码</h1>
                <img class="footer-erweima" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/images/erweima.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        toHome() {
            this.$router.push({
                name: 'home'
            })
        }
    }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
    width: 100%;
    height: 222px;
    background: url('./../assets/images/footer-bg.png') center no-repeat;
    background-size: 100% 100%;
}
.footer-box {
    width: 1200px;
    height: 182px;
    padding-top: 40px;
    margin: 0 auto;
    color: #fefefe;
    display: flex;
}
.footer-box p {
    font-size: 14px;
    color: #cacaca;
    margin-bottom: 6px;
}
.footer-logo {
    width: 79px;
    height: 31px;
    cursor: pointer;
}
.footer-erweima {
    width: 102px;
    height: 102px;
}
.footer-box h2 {
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 10px;
}
.footer-box h1 {
    font-size: 24px;
    margin-bottom: 20px;
}
.footer-box-contact {
    margin-left: 260px;
}
.footer-box-erweima {
    margin-left: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.footer-police{
    width: 19px;
    height: 19px;
}
.footer-p p{
    margin:auto auto auto 5px;
}
/* .footer-p img{
    margin: auto auto;
}  */
.footer-box-logo{
    line-height: 27px;
}
</style>
